import Vue from "vue";
// const validationErrors = Vue.observable({
//   serverError: "",
//   ErrorsKeys: []
// });
// Vue.mixin({
//   data() {
//     return {
//       validationErrors
//     };
//   }
// });

Vue.directive("input-validation", {
  update(el, bind, vnode) {
    const {
      getters: { serverErrors }
    } = vnode.context.$store;

    if (serverErrors !== null) {
      if (serverErrors[bind.value]) {
        el.style.border = "1px solid rgb(197, 89, 0)";
      } else {
        el.style.border = "1px solid transparent";
      }
    } else {
      el.style.border = "1px solid transparent";
    }
  }
});
